import React, {useState} from "react";
import "./ServiceCategoryReadMoreComponent.scss";
import {ImageConfig} from "../../../constants";


interface ServiceCategoryReadMoreComponentProps {
    appointmentDetails: any;
    setOpenModal?: any;
}

const ServiceCategoryReadMoreComponent = (props: ServiceCategoryReadMoreComponentProps) => {

    const {appointmentDetails, setOpenModal} = props;
    const mainCategory = appointmentDetails?.category_details;
    const service = appointmentDetails?.service_details;

    // State to track which one is selected: "category" or "service"
    const [selectedType, setSelectedType] = useState<"category" | "service">("category");

    return (
        <div className="service-category-read-more-component">
            {/* Left Pane: List of Options */}
            <div className="left-pane">
                <h2>Get to know our <br/>services better</h2>
                <p>Select an option below to know more about it.</p>

                {/* Option 1: Main Category */}
                <div
                    className={`option ${selectedType === "category" ? "selected" : ""}`}
                    onClick={() => setSelectedType("category")}
                >
                    <img src={mainCategory?.image?.url} alt={mainCategory?.name} className="option-icon"/>
                    <span>{mainCategory?.name}</span>
                    <span className="arrow-icon">
                          {selectedType === "category"
                              ?
                              <ImageConfig.CircleRightArrowFilled/> : <ImageConfig.CircularFilledIcon/>
                          }
                         </span>
                </div>

                {/* Option 2: Service (if it exists) */}
                {service && (
                    <div
                        className={`option ${selectedType === "service" ? "selected" : ""}`}
                        onClick={() => setSelectedType("service")}
                    >
                        <img src={service?.image?.url} alt={service?.name} className="option-icon"/>
                        <span>{service?.name}</span>
                        <span className="arrow-icon">
                    {selectedType === "service"
                        ?
                        <ImageConfig.CircleRightArrowFilled/> : <ImageConfig.CircularFilledIcon/>
                    }
                  </span>
                    </div>
                )}
            </div>


            {/* Right Pane: Selected Details */}
            <div className="right-pane">
                <div className="close-icon" onClick={() => setOpenModal(false)}>
                    <ImageConfig.CloseIcon/>
                </div>
                {selectedType === "category" && (
                    <div className="details">
                        <h3>{mainCategory?.name}</h3>
                        <div dangerouslySetInnerHTML={{__html: mainCategory?.description}}/>
                    </div>
                )}

                {selectedType === "service" && service && (
                    <div className="details">
                        <h3>{service?.name}</h3>
                        <div dangerouslySetInnerHTML={{__html: service?.description}}/>
                    </div>
                )}
            </div>

        </div>
    )
        ;
};

export default ServiceCategoryReadMoreComponent;
